var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-table"},[_c('div',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.$t('price-adj.messages.order-tab'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }